import './sliderPhotos.css';

const compareModule = () => import(/* webpackChunkName: 'components/compare' */'../compare/compare');

import { sliderPhotosTpl } from './sliderPhotosTpl';

dispatcher.listenTo(dispatcher, 'sliderPhotos:init', function () {
  sliderPhotos.initialize();
});

dispatcher.listenTo(dispatcher, 'sliderPhotos:initbis', function (className) {
  sliderPhotos.init(className);
});

export const sliderPhotos = {
  mainSelector: '.js-sliderPhotos',
  sliderSelector: '.js-sliderPhotos-slider',
  slideSelector: '.swiper-slide',
  openPopinSelector: '.js-openPopinOnClick',
  nbTotalSlideSelector: '.js-sliderPhotos-total-count',
  goToLastSlideSelector: '.js-goToLastSlide',
  dotSelector: '.js-sliderPhotos-dot',
  dotsContainerSelector: '.js-dots-container',
  prevArrowSelector: '.js-sliderPhotos-arrow-left',
  nextArrowSelector: '.js-sliderPhotos-arrow-right',

  // You need to call this function manually when Html is loaded or a new sliderPhotos is added to the DOM
  initialize: function (results = false) {
    if (results) {// when results transmitted => we load photos from previous search ajax call
      this.initOnLoad(results);
    } else {
      // init() when initialize is called manually.
      this.init();
    }

    // init() on window resize for better responsive experience
    // Timeout is used to prevent triggering init() multiple times for performance issues
    // .off() is used to prevent registering many times the same eventListener on window if initialize is called many times
    let windowResizeTimeout = false;

    const resizeCallback = () => {
      if (windowResizeTimeout) {
        clearTimeout(windowResizeTimeout);
        windowResizeTimeout = false;
      }
      windowResizeTimeout = setTimeout(() => {
        this.init('resize');
      }, 400);
    };

    $(window).off('resize', resizeCallback).on('resize', resizeCallback);

    // the init function will check if the slider is currently in viewport that's why we added the scroll detection below for better lazyload experience.
    let windowScrollTimeout = false;

    const scrollCallback = () => {
      if (windowScrollTimeout) {
        clearTimeout(windowScrollTimeout);
        windowScrollTimeout = false;
      }
      windowScrollTimeout = setTimeout(() => {
        this.init();
      }, 150);
    };
    $(window).off('scroll', scrollCallback).on('scroll', scrollCallback);

    $(document).off('click', this.goToLastSlideSelector).on('click', this.goToLastSlideSelector, (e) => {
      this.goToLastSlide(e);
    });
  },

  // loading sliders on first page load (need results)
  initOnLoad: function (results) {
    const isHousingCartouche = $('#js-resultList').hasClass('domainAccommodations-resultList');
    const cartouchePrefix = isHousingCartouche ? 'accCart' : 'cartouche';
    const pictureContainerPrefix = isHousingCartouche ? 'accCart' : 'cartoucheDomain';
    const resolutionMobile = isHousingCartouche ? '566x250' : '640x480';
    const resolutionTablet = isHousingCartouche ? '500x375' : '640x480';
    const resolutionDesktop = isHousingCartouche ? '566x250' : '640x480';

    $.each(results, (key, product) => {
      const photoList = product.photo;

      if (typeof photoList !== 'undefined' && photoList !== null) {
        const lengthDesktop = typeof photoList[resolutionDesktop] === 'undefined' ? 0 : photoList[resolutionDesktop].length;
        const lengthTablet = typeof photoList[resolutionTablet] === 'undefined' ? 0 : photoList[resolutionTablet].length;
        const lengthMobile = typeof photoList[resolutionMobile] === 'undefined' ? 0 : photoList[resolutionMobile].length;
        let maxLength = Math.max.apply(Math, [lengthDesktop, lengthTablet, lengthMobile]);
        if (typeof photoList[resolutionDesktop] === 'undefined') {
          photoList[resolutionDesktop] = [];
          for (let i = 0; i < maxLength; i++) {
            photoList[resolutionDesktop].push(GLOBAL_SCRIPTS.STATIC_VERSION + '/assets/images/default/'+resolutionDesktop+'.jpg');
          }
        }
        if (typeof photoList[resolutionTablet] === 'undefined') {
          photoList[resolutionTablet] = [];
          for (let i = 0; i < maxLength; i++) {
            photoList[resolutionTablet].push(GLOBAL_SCRIPTS.STATIC_VERSION + '/assets/images/default/' + resolutionTablet + '.jpg');
          }
        }
        if (typeof photoList[resolutionMobile] === 'undefined') {
          photoList[resolutionMobile] = [];
          for (let i = 0; i < maxLength; i++) {
            photoList[resolutionMobile].push(GLOBAL_SCRIPTS.STATIC_VERSION + '/assets/images/default/' + resolutionMobile + '.jpg');
          }
        }
      }
      const dataTemplate = {
        productCode: product.offer.code,
        brandCode: product.brand.code,
        resolutionToUse: {
          desktop: resolutionDesktop,
          tablet: resolutionTablet,
          mobile: resolutionMobile
        },
        openPopinOnClick: {
          desktop: true,
          tablet: true,
          mobile: true
        },
        photosDatas: typeof photoList !== 'undefined' && photoList !== null ? photoList : {
          '500x375': [GLOBAL_SCRIPTS.STATIC_VERSION + '/assets/images/default/500x375.jpg'],
          '566x250': [GLOBAL_SCRIPTS.STATIC_VERSION + '/assets/images/default/566x250.jpg'],
          '640x480': [GLOBAL_SCRIPTS.STATIC_VERSION + '/assets/images/default/640x480.jpg']
        },
        typeOfResult: isHousingCartouche ? 'housing' : 'domain',
        virtualTour: isHousingCartouche ? product.housing.virtualtour : ''
      };

      if (isHousingCartouche) {
        dataTemplate.housingCode = product.housing.code;
      }

      const slider = sliderPhotosTpl(dataTemplate);

      let $cartoucheContainer = $(`#${cartouchePrefix}_${key}`);

      if (!$cartoucheContainer.length) {
        $cartoucheContainer = $(`[id="${cartouchePrefix}_${product.housing.code}"][data-pricecollapse="${product.cache.priceCollapse}"]`);
      }
      if ($cartoucheContainer.length) {
        const $pictureContainer = $cartoucheContainer.find(`.${pictureContainerPrefix}-pictureContainer`);
        $pictureContainer.find(this.slideSelector).remove();
        $pictureContainer.prepend(slider);
      }
    });

    this.init();
  },

  init: function (className = '') {
    const mainSelector = className !== '' ? `${className}` : this.mainSelector;
    // Loop through every sliders in the DOM
    $(mainSelector).each((_i, el) => {
      const $sliderPhoto = $(el);
      if ($sliderPhoto.hasClass('init')) {
        // If a slider is already init, we check if the device is still the same, if not, render it again
        if ((DEVICE.isDesktop && $sliderPhoto.attr('data-init-device') !== 'desktop') || (DEVICE.isTablet && $sliderPhoto.attr('data-init-device') !== 'tablet') || (DEVICE.isMobile && $sliderPhoto.attr('data-init-device') !== 'mobile')) {

          // Then we update the data-init-device attribute with the new value
          this.updateDataInitDeviceAttr($sliderPhoto);

          // We set the right images urls and width/height attributes according to the device
          this.updateImageUrlsAndDimensionsByDevice($sliderPhoto);

          // And then we render the slider again
          if (checkIf$ElemInViewport($sliderPhoto)) {
            this.render($sliderPhoto);
          }
        } else if (!$sliderPhoto.hasClass('rendered')) {
          if (checkIf$ElemInViewport($sliderPhoto)) {
            this.render($sliderPhoto);
          }
        }
      } else {
        // First init
        $sliderPhoto.addClass('init');

        // Creation of an unique id for this sliderPhoto, it will be used later to init fancybox
        const unique_slider_id = Math.random().toString(36).substring(2);
        $sliderPhoto.attr('id', `_${unique_slider_id}`);

        // We save the current device as data attribute to use it above
        this.updateDataInitDeviceAttr($sliderPhoto);

        // We set the right images urls and width/height attributes according to the device
        this.updateImageUrlsAndDimensionsByDevice($sliderPhoto);

        // We init the fancybox
        this.initOpenPopin($sliderPhoto, `_${unique_slider_id}`);

        /* Render when the user scrolls into view */
        /* or render swiper if you are on the popin cottage details from eresa/popin mode (toInit class) */
        /* WPI-36771  checkIf$ElemInViewport($sliderPhoto) se déclanche qu'une seule fois et ne se update plus apres scroll , donc seulement le premier bloc est rendered*/

        if (checkIf$ElemInViewport($sliderPhoto) || $sliderPhoto.hasClass('toInit')) {
          this.render($sliderPhoto);
        }
      }
    });
  },

  getResolutionX: function ($sliderPhoto) {
    return $sliderPhoto.attr('data-resolution-' + (DEVICE.isDesktop ? 'desktop' : DEVICE.isTablet ? 'tablet' : 'mobile')).split('x')[0];
  },

  getResolutionY: function ($sliderPhoto) {
    return $sliderPhoto.attr('data-resolution-' + (DEVICE.isDesktop ? 'desktop' : DEVICE.isTablet ? 'tablet' : 'mobile')).split('x')[1];
  },

  // Warning: call this method only when slider is not initialised yet
  updateImageUrlsAndDimensionsByDevice: function ($sliderPhoto) {
    const isHousingCartouche = $('#js-resultList').hasClass('domainAccommodations-resultList');
    const resolutions = {
      mobile: {
        x: isHousingCartouche ? 566 : 640,
        y: isHousingCartouche ? 250 : 480
      },
      tablet: {
        x: isHousingCartouche ? 500 : 640,
        y: isHousingCartouche ? 375 : 480
      },
      desktop: {
        x: isHousingCartouche ? 566 : 640,
        y: isHousingCartouche ? 250 : 480
      }
    };

    const resolutionX = DEVICE.isDesktop ? resolutions.desktop.x : DEVICE.isTablet ? resolutions.tablet.x : resolutions.mobile.x;
    const resolutionY = DEVICE.isDesktop ? resolutions.desktop.y : DEVICE.isTablet ? resolutions.tablet.y : resolutions.mobile.y;

    $sliderPhoto.find(this.slideSelector + ' img').each((_i, el) => {
      const $img = $(el);
      const attribute_name = DEVICE.isDesktop ? 'data-url-desktop' : DEVICE.isTablet ? 'data-url-tablet' : 'data-url-mobile';
      const url = $img.attr(attribute_name);

      $img.attr('width', resolutionX).attr('height', resolutionY);

      if (url.indexOf(GLOBAL_SCRIPTS.STATIC_VERSION) === -1) {
        if (url.indexOf(GLOBAL_SCRIPTS.BASELINK_MEDIA) === -1) {
          $img.attr('data-src', GLOBAL_SCRIPTS.BASELINK_MEDIA + url);
        } else {
          $img.attr('data-src', url);
        }
      } else {
        // Products without photos are using GLOBAL_SCRIPTS.STATIC_VERSION and we don't need to prepend it
        $img.attr('data-src', url);
      }
    });
  },

  updateDataInitDeviceAttr: function ($sliderPhoto) {
    if (DEVICE.isDesktop) {
      $sliderPhoto.attr('data-init-device', 'desktop');
    } else if (DEVICE.isTablet) {
      $sliderPhoto.attr('data-init-device', 'tablet');
    } else {
      $sliderPhoto.attr('data-init-device', 'mobile');
    }
  },

  render: function ($sliderPhoto) {
    const _self = this;
    const sliderParams = {
      slidesPerView: 1,
      slidesPerGroup: 1,
      loop: true,
      pagination: {
        el: '.swiper-pagination',
        dynamicBullets: true
      }
    };

    $sliderPhoto.addClass('rendered');

    // Disable swiping on desktop : the user should only use the arrows
    if (DEVICE.isDesktop) {
      sliderParams.noSwiping = true;
      sliderParams.noSwipingClass = 'swiper-slide';
    }

    dispatcher.trigger('lazyload:update');

    // And Init slider + counter
    SwiperComponents.initSlider(`#${$sliderPhoto.attr('id')} .js-sliderPhotos-slider`, sliderParams, [{
      swiperEvent: 'transitionStart',
      function: function () {
        dispatcher.trigger('lazyload:update');
      }
    }]);
  },

  initOpenPopin: function ($sliderPhotos, unique_slider_id) {
    const enableDesktop = $sliderPhotos.is('[data-open-popin-desktop="true"]');
    const enableTablet = $sliderPhotos.is('[data-open-popin-tablet="true"]');
    const enableMobile = $sliderPhotos.is('[data-open-popin-mobile="true"]');
    if (enableDesktop || enableTablet || enableMobile) {
      const $slides = $sliderPhotos.find(this.slideSelector + ' ' + this.openPopinSelector + '[data-code]');
      if ($slides.length) {
        let enableFancybox = false;
        $slides.each((_i, slide) => {
          // Products without photos are using GLOBAL_SCRIPTS.STATIC_VERSION to construct the placeholder photo urls
          // So we check if at least one image has a photo before initialising the fancyboxview
          const $slide = $(slide);
          const url = slide.hasAttribute('data-src') ? $slide.attr('data-src') : '';

          if (url.indexOf(GLOBAL_SCRIPTS.STATIC_VERSION) === -1) {
            enableFancybox = true;
            return false;
          }
        });

        if (enableFancybox) {
          const $firstSlide = $slides.first();
          const productCode = $firstSlide.data('code');
          const brandCode = $firstSlide.data('brand');
          const housingCode = $firstSlide.data('housingcode');
          const isDomain = typeof housingCode === 'undefined';

          let ajaxParams = {
            offers: productCode,
            season: 'SUMMER',
            formats: '800x600',
            selection: 'residence',
            brandCode: brandCode,
            order: 'order',
            univers: GLOBAL_SCRIPTS.UNIVERS
          };

          if (!isDomain) {
            ajaxParams = {
              ...ajaxParams,
              housings: housingCode,
              selection: 'typologie'
            };
          }

          let selector = '';

          if (enableDesktop) {
            const tempSelector = 'body.deviceIsDesktop #' + unique_slider_id + ' ' + this.openPopinSelector + '[data-code="' + productCode + '"]';
            selector += tempSelector;
            $(document).on('click', 'body.deviceIsDesktop #' + unique_slider_id + ' .sliderPhotos-counter', e => {
              e.preventDefault();
              $(tempSelector.replace(this.openPopinSelector, '.swiper-slide-active ' + this.openPopinSelector)).trigger('click');
            });
          }

          if (enableTablet) {
            const tempSelector = 'body.deviceIsTablet #' + unique_slider_id + ' ' + this.openPopinSelector + '[data-code="' + productCode + '"]';

            if (selector !== '') {
              selector += ', ';
            }

            selector += tempSelector;
            $(document).on('click', 'body.deviceIsTablet #' + unique_slider_id + ' .sliderPhotos-counter', e => {
              e.preventDefault();
              $(tempSelector.replace(this.openPopinSelector, '.swiper-slide-active ' + this.openPopinSelector)).trigger('click');
            });
          }

          if (enableMobile) {
            const tempSelector = 'body.deviceIsMobile #' + unique_slider_id + ' ' + this.openPopinSelector + '[data-code="' + productCode + '"]';

            if (selector !== '') {
              selector += ', ';
            }

            selector += tempSelector;
            $(document).on('click', 'body.deviceIsMobile #' + unique_slider_id + ' .sliderPhotos-counter', e => {
              e.preventDefault();
              $(tempSelector.replace(this.openPopinSelector, '.swiper-slide-active ' + this.openPopinSelector)).trigger('click');
            });
          }

          const fancyParametersDiaporama = {
            unique_slider_id: unique_slider_id,
            selector: selector,
            popinName: 'galleryPhotos',
            fancyType: 'ajaxGalleryHousing',
            genericAjaxParams: ajaxParams,
            slideClose: false,
            options: {
              buttons: ['close'],
              showCloseButton: true,
              overlayClose: false,
              isModal: false,
              preventScroll: true,
              clickSlide: false,
              clickOutside: false,
              touch: true,
              loop: true,
              baseClass: 'fancybox-skin--white'
            }
          };

          new FancyboxView(fancyParametersDiaporama);
        }
      }
    }
  },

  goToLastSlide: function (event) {
    const $slider = $(event.currentTarget).parents(this.mainSelector);
    const $sliderPhotos = $slider.find(this.sliderSelector);
    const nbSlides = parseInt($slider.find(this.nbTotalSlideSelector).html().trim());
    const swiperInstance = $sliderPhotos[0].swiper;
    const lastSlideIdx = nbSlides - 1;

    swiperInstance.slideTo(lastSlideIdx);

    const gaActionsList = {
      [`tab_${GLOBAL_SCRIPTS.UNIVERS}_cottages`]: 'Item list',
      [`tab_${GLOBAL_SCRIPTS.UNIVERS}_activities`]: 'Pop in activities',
      [`tab_${GLOBAL_SCRIPTS.UNIVERS}_catering`]: 'Pop in service'
    };
    const gaActionValue = typeof PRODUCT_SCRIPTS !== 'undefined' ? gaActionsList[PRODUCT_SCRIPTS.PRODUCT_TAB] : 'Item list';

    Tracking.dataLayerPush({
      event: 'clickEvent',
      gaCategory: 'Virtual medias',
      gaAction: gaActionValue,
      gaLabel: 'click on the icon 360'
    });
  }
};